// extracted by mini-css-extract-plugin
module.exports = {"scheduler":"styles-m__scheduler---1OOpl","completeAllTasks":"styles-m__completeAllTasks---1-L3W"};